import styled from "styled-components";
import Button from "./Button";

const ButtonToolbar = styled.div`
  & ${Button} + ${Button} {
    margin-left: 4px;
  }
`;

export default ButtonToolbar;



// WEBPACK FOOTER //
// ./src/components/ButtonToolbar.js